module.exports = __webpack_public_path__ + "img/credible-layer2.dd466d96.svg";